import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedArea } from "./components/ProtectedArea";
import { AccountPage } from "./pages/AccountPage";
import { AgentNewTicketPage } from "./pages/AgentNewTicketPage";
import { CustomersPage } from "./pages/CustomersPage";
import { DashboardPage } from "./pages/DashboardPage";
import { DevicesPage } from "./pages/DevicesPage";
import { DeviceDetailPage } from "./pages/DeviceDetailPage";
import { KnowledgeBaseArticlePage } from "./pages/KnowledgeBaseArticlePage";
import { KnowledgeBasePage } from "./pages/KnowledgeBasePage";
import { LoginPage } from "./pages/LoginPage";
import { NewTicketPage } from "./pages/NewTicketPage";
import { OrganizationsPage } from "./pages/OrganizationsPage";
import { ReportsPage } from "./pages/ReportsPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { TicketDetailPage } from "./pages/TicketDetailPage";
import { TicketsPage } from "./pages/TicketsPage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage role="client" />} />
      <Route path="/recuperar-senha" element={<ResetPasswordPage />} />
      <Route path="/desk/login" element={<LoginPage role="agent" />} />

      <Route element={<ProtectedArea role="client" />}>
        <Route index element={<DashboardPage />} />
        <Route path="/chamados" element={<TicketsPage />} />
        <Route path="/chamados/:ticketId" element={<TicketDetailPage />} />
        <Route path="/novo" element={<NewTicketPage />} />
        <Route path="/conta" element={<AccountPage />} />
      </Route>

      <Route element={<ProtectedArea role="agent" />}>
        <Route path="/desk" element={<DashboardPage mode="agent" />} />
        <Route path="/desk/chamados" element={<TicketsPage mode="agent" />} />
        <Route path="/desk/chamados/:ticketId" element={<TicketDetailPage mode="agent" />} />
        <Route path="/desk/novo" element={<AgentNewTicketPage />} />
        <Route path="/desk/clientes" element={<CustomersPage />} />
        <Route path="/desk/organizacoes" element={<OrganizationsPage />} />
        <Route path="/desk/equipamentos" element={<DevicesPage />} />
        <Route path="/desk/equipamentos/:deviceId" element={<DeviceDetailPage />} />
        <Route path="/desk/base" element={<KnowledgeBasePage />} />
        <Route path="/desk/base/:articleId" element={<KnowledgeBaseArticlePage />} />
        <Route path="/desk/relatorios" element={<ReportsPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
